import { createSelector } from '@reduxjs/toolkit'

import { ApplicationState } from 'redux/Stores/types'
import { TTaskResponse } from 'redux/api/Tasks'
import { sortDateDesc } from 'utils/sortHelper'

/** Every stored task, newest first. */
export const selectTasks = createSelector(
  [(state: ApplicationState) => state.TaskStore.data],
  (data): TTaskResponse[] =>
    Object.values(data).sort((a, b) => sortDateDesc(a.created_at, b.created_at))
)

export const selectTask = createSelector(
  [
    (state: ApplicationState) => state.TaskStore.data,
    (_: ApplicationState, id: string | null) => id
  ],
  (data, id): TTaskResponse | null => (id ? data[id] ?? null : null)
)

export const selectTasksFetchStatus = (state: ApplicationState) =>
  state.TaskStore.state
